(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('inventoryApp')
        .constant('CONST_EXPORTS', {
        	'EDIT_STATUS_CODE': "E",
        	'VIEW_STATUS_CODE': "V",
        	'REMOVE_STATUS_CODE': "R",
        	'CREATE_STATUS_CODE': "C",
        	'MODIFY_STATUS_CODE': "M",//Chỉnh sửa khi duyệt
        	'APPROVE_STATUS_CODE': "A",
        	'EDIT_STATUS_NAME': "Điều chỉnh phiếu đề nghị điều phối CN",
        	'VIEW_STATUS_NAME': "Xem phiếu đề nghị điều phối CN",
        	'REMOVE_STATUS_NAME': "Hủy phiếu đề nghị điều phối CN",
        	'CREATE_STATUS_NAME': "Tạo phiếu đề nghị điều phối CN",
        	'MODIFY_STATUS_NAME': "Điều chỉnh duyệt ĐN điều phối CN",//Chỉnh sửa khi duyệt
        	'APPROVE_STATUS_NAME': "Duyệt phiếu ĐN điều phối CN",
        	'APPROVE_TITLE':"DUYỆT XUẤT HÀNG/ĐIỀU PHỐI",
        	'CREATE_TITLE':"ĐỀ NGHỊ XUẤT HÀNG/ĐIỀU PHỐI",
        	'APPROVE_STATUS_VIEW': "approve",
        	'CREATE_STATUS_VIEW': "create",
        	'URL_BOTRANSFER':"botransfer/#/botransfer"
        });
})();
